import { render, staticRenderFns } from "./FarmsView.vue?vue&type=template&id=d51c58da&"
import script from "./FarmsView.vue?vue&type=script&lang=ts&"
export * from "./FarmsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports